import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./contexts/AuthContext";
import { ProtectedRoute } from "./components/auth/ProtectedRoute";
import { Login } from "./pages/Login";
import { ForgotPassword } from "./pages/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword";
import { ChangePassword } from "./pages/ChangePassword";
import { Dashboard } from "./pages/Dashboard";
import { OccurrenceBook } from "./pages/OccurrenceBook";
import { MapView } from "./pages/MapView";
import { Customers } from "./pages/Customers";
import { Contractors } from "./pages/Contractors";
import { Pricing } from "./pages/Pricing";
import { Billing } from "./pages/Billing";
import { Reports } from "./pages/Reports";
import { Settings } from "./pages/Settings";
import { AcceptInvite } from "./pages/AcceptInvite";
import { Portal } from "./pages/Portal";

const Guard = ({ children, roles }) => (
  <ProtectedRoute roles={roles}>{children}</ProtectedRoute>
);

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors closeButton />
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/accept-invite" element={<AcceptInvite />} />
            <Route path="/change-password" element={<Guard><ChangePassword /></Guard>} />
            <Route path="/portal" element={<Guard roles={['customer']}><Portal /></Guard>} />
            <Route path="/" element={<Guard roles={['admin', 'operator', 'accounts']}><Dashboard /></Guard>} />
            <Route path="/dashboard" element={<Guard roles={['admin', 'operator', 'accounts']}><Dashboard /></Guard>} />
            <Route path="/occurrence-book" element={<Guard roles={['admin', 'operator', 'accounts']}><OccurrenceBook /></Guard>} />
            <Route path="/map-view" element={<Guard roles={['admin', 'operator', 'accounts']}><MapView /></Guard>} />
            <Route path="/customers" element={<Guard roles={['admin', 'operator', 'accounts']}><Customers /></Guard>} />
            <Route path="/contractors" element={<Guard roles={['admin', 'operator', 'accounts']}><Contractors /></Guard>} />
            <Route path="/pricing" element={<Guard roles={['admin', 'accounts']}><Pricing /></Guard>} />
            <Route path="/billing" element={<Guard roles={['admin', 'accounts']}><Billing /></Guard>} />
            <Route path="/reports" element={<Guard roles={['admin', 'operator', 'accounts']}><Reports /></Guard>} />
            <Route path="/settings" element={<Guard roles={['admin']}><Settings /></Guard>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
